// @flow

import React from 'react';
import {
  stateClasses,
  stateLabels,
} from '../orderStates';

export const formatOrderState = (state: number) => (
  <span>
    <i className={`fa fa-circle order-status ${stateClasses[state]}`} />{stateLabels[state]}
  </span>
);



// WEBPACK FOOTER //
// ./src/helpers/tableHelpers.js